(ns app.reels.ui-register
  "Replicant UI register entries for the Instagram Reels slice."
  (:require [app.reels.page :as page]))

(def register
  [page/page])
